import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  KYC_REQUIRED,
} from "../types/authTypes";


const initialState = {
  loading: false,
  isAuthenticated: false,
  user: null,      // will hold { id, username, user_type, … }
  error: null,
  loggingOut: false,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, loading: true, error: null };

    case LOGIN_SUCCESS:
      // console.log("Login success action payload:", action.payload);
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload,
        loggingOut: false,
        error: null
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        error: action.payload
      };

    case LOGOUT_REQUEST:
      return { ...state, loggingOut: true, error: null };

    case LOGOUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        accessToken: null,
        refreshToken: null,
        loading: false,
        error: null,
      };

    case LOGOUT_FAILURE:
      return { ...state, loggingOut: false, isAuthenticated: false, error: action.payload };

    case KYC_REQUIRED:
      return { ...state, loading: false, isAuthenticated: false, kycRequired: true };

    default:
      return state;
  }
}